import { Tooltip } from "antd"
import moment from "moment"
import { disable_leaderboard, disable_pencil, enable_leaderboard, info_icon, pencil_img } from "../../assets/images"
import ToggleButton from "../../components/tailwind/atoms/ToggleButton"
import { SALES_ROLE } from "../../constants/overview"

const stepathonListPageSchema = ({data, editStepathon, openModal, openLeaderBoard, UploadAndViewTeams}) => {
  let getToggleStatus = {
    'activate' : true,
    'deactivate' : false
  }
  const stepathonType = {
    team: 'Team',
    individual: 'Individual',
    milestone: 'Milestone',
  };
  let toggleStatus = getToggleStatus[data.status]
  let finishedStepathon = data.tag === 'Finished'
  let yTSStepathon = data.tag === 'Yet to Start'
  let onGoing = data.tag === 'Ongoing'
  let stepathon_type = stepathonType[data.stepathon_type]
  let opacity = data.status === 'deactivate' || (data.stepathon_type === 'team' && data.stepathon_mode === 'closed' && !data.have_teams)
                    ||  (data.stepathon_type === 'individual' && data.stepathon_mode === 'closed' && !data.have_members)  ? 'opacity-50' : ''
  opacity = onGoing ? '' : opacity

  const my_view_team = () => {
    if (data.stepathon_type === 'team' && data.stepathon_mode === 'closed') {
      return (
        <button
          className={`text-blue-600 text-sm font-semibold ${yTSStepathon ? '' : opacity} ${(data.status === 'deactivate' || ((!data.have_teams && finishedStepathon) || (!data.have_teams && onGoing)) || SALES_ROLE === 'sales') ? 'cursor-not-allowed' : ''}`}
          disabled={!toggleStatus || ((!data.have_teams && finishedStepathon) || (!data.have_teams && onGoing)) || SALES_ROLE === 'sales' ? true : false}
          onClick={() => UploadAndViewTeams( data.have_teams ? 'view_teams' : 'upload_teams', data)}
        >
          {data.have_teams ? 'View teams' : 'Upload teams'}
        </button>
      )
    } else if (data.stepathon_type === 'individual' && data.stepathon_mode === 'closed') {
      return (
        <button
          className={`text-blue-600 text-sm font-semibold ${yTSStepathon ? '' : opacity} ${(data.status === 'deactivate' || ((!data.have_members && finishedStepathon) || (!data.have_members && onGoing)) || SALES_ROLE === 'sales') ? 'cursor-not-allowed' : ''}`}
          disabled={!toggleStatus || ((!data.have_members && finishedStepathon) || (!data.have_members && onGoing)) || SALES_ROLE === 'sales' ? true : false}
          onClick={() => UploadAndViewTeams(data.have_members ? 'view_members' : 'upload_members', data)}
        >
          {data.have_members ? 'View members' : 'Upload members'}
        </button>
      )
    } else  {
      return (
        <p className={`flex flex-row align-middle ${opacity} ${data.status === 'deactivate' ? 'cursor-not-allowed' : ''}`}>Open stepathon
          { data.stepathon_type === 'team' &&
            <Tooltip placement='bottom'  title='You can only upload teams to “Closed stepathon”'><img src={info_icon}  style={{width: '14px', marginLeft: '4px'}} alt='info' /></Tooltip>
          }
        </p>
      )
    }
  }
  
  const tooltipText = {
    'Yet to Start' : 'Please make sure to add the ' +( stepathon_type === 'Team' ? 'teams' : 'members') + ' for the stepathon, before the start date. Otherwise the stepathon will be automatically converted into an "Open stepathon"',
    'Ongoing' : `Looks like you haven't uploaded the stepathon ` + (stepathon_type === 'Team' ? 'teams' : 'members') +` on time , so we've automatically converted the "Closed stepathon" into an " Open stepathon"`
  }

  let tooltip = data.stepathon_type === 'team' ? (!data.have_teams && data.stepathon_mode === 'closed' ) : (!data.have_members && data.stepathon_mode === 'closed')

  return (
    <tr className='text-gray-600' key={data.id} >
      <td className={`pl-3 py-4  ${opacity} flex`}>
          {data.name}
          { tooltip &&
          <Tooltip placement='bottom'  title={tooltipText[data.tag]}>  
            <img className='ml-1' src={info_icon}  style={{width: '14px', marginLeft: '4px'}} alt='info' />
          </Tooltip>
          }
      </td>
      <td className={`pl-3 pr-4 py-4 w-1/6 ${opacity}`} > {stepathon_type} </td>
       <td className={`pl-3 pr-4 py-4 w-1/6 ${opacity}`}>{data.start_date}</td>
       <td className={`pl-3 pr-4 py-4 w-1/6 ${opacity}`}>{data.end_date}</td>
       <td className={`pl-3 pr-4 py-4 w-1/6`}>
        {my_view_team()}
       </td>
       <td className='content-center w-1/6'>
       <div className="flex flex-row" >
          {data.tag !== 'Finished' || !(data.end_date === moment().format('DD-MM-YYYY')) ? <span onClick={() => editStepathon(data)} className={`px-3.5 relative align-middle ${(data.status === 'deactivate' || SALES_ROLE === 'sales') ? 'cursor-not-allowed' : ''}`} disabled={toggleStatus || SALES_ROLE === 'sales' ? true : false}> <Tooltip  placement='bottom' title={`${ SALES_ROLE === 'sales' ? '' : 'Edit stepathon'}`} ><img src={( (data.tag !== 'Finished' && toggleStatus) || (data.tag === 'Ongoing' && toggleStatus) ) ? pencil_img : disable_pencil }/></Tooltip></span> : <span onClick={() => editStepathon(data)} className={`px-3.5 relative align-middle cursor-not-allowed`} ><img src={disable_pencil}/></span>}
          {data.tag === 'Finished'|| data.tag === 'Ongoing'  ? <ToggleButton name = 'status'  toggle={toggleStatus} onChangeHandler={(e) => openModal(e,data.id)}  disabled={data.tag !== 'Yet to Start' || SALES_ROLE === 'sales' ? true : false}/> : <Tooltip  placement='bottom' mouseLeaveDelay={0} mouseEnterDelay={0} title={`${toggleStatus ? 'Disable stepathon' : 'Enable stepathon' } `}> <ToggleButton name = 'status'  toggle={toggleStatus} onChangeHandler={(e) => openModal(e,data.id)}  disabled={data.tag !== 'Yet to Start' || SALES_ROLE === 'sales' || (data.stepathon_type === 'team' && data.stepathon_mode === 'closed' && !data.have_teams)  ? true : false}/></Tooltip>}
          <Tooltip  placement='bottom' title='View leaderboard'><span className={`px-3.5 ${data.status === 'deactivate' ? 'cursor-not-allowed' : ''}`}><img  src={(data.tag === 'Yet to Start' ||  (data.status === 'deactivate' &&  data.tag === 'Ongoing')) ? disable_leaderboard : enable_leaderboard } onClick={() => openLeaderBoard(data)} ></img></span></Tooltip> 
        </div>
        </td>
    </tr>
  )
}

export default stepathonListPageSchema